import React, { useEffect, useState } from 'react';
import { Col, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { mustBeArray } from '../../utils/lib';
import { apiRequest } from '../../utils/request';
import Select from "react-select";
import {
    CLIENT_REQUEST_APPROVED_ID,
    CLIENT_REQUEST_IN_PROGRESS_CLIENT_ACTIONS_ID,
    CLIENT_REQUEST_PENDING_CLIENT_ACTIONS_ID, CLIENT_REQUEST_PENDING_ID
} from '../../constants';
import DragAndDropUpload from '../Common/DragAndDropUpload';
import StatusHistoryList from '../ClientRequest/StatusHistoryList';

const UrgentRequestModal = ({viewRequestModal, title, handleFileUploads, images, handleNoteChange,
                            handleFileDelete, submitButtonText, notes, submitLoading,
                            handleRequest, handleModalClose, activeRequestType, handleTankChange, selectedTank, 
                            isSuperAdmin, requestStatus, instruction, approveLoading, declineLoading, pendingLoading, saveLoading,
                            activePendingRequest}) => {
    const [tanks, setTanks] = useState([]);

    useEffect(() => {
        if(viewRequestModal && (activeRequestType === "tank")){
            fetchTanksList();
        }
    }, [viewRequestModal]);
                                
    const handleAttachmentFieldChange = (fileList) => { 
          handleFileUploads({fileList});
      };

    const fetchTanksList = () => {
        apiRequest('/api/clientrequests/location-tanks')
            .then(x => {
                const availableTanks = mustBeArray(x && x.data && x.data.locationTanks).map(y => {
                    return {
                        value: y.tankId,
                        label: `${y.locationName} / ${y.tankName}`,    
                        locationId: y.locationId                        
                    };
                });
                setTanks(availableTanks);
            });
    };

    const getModalFooter = () => {
        if(isSuperAdmin){
            return(
                <div className="flex justify-content-between align-items-end full-width flex-wrap">
                            <button className="btn btn-white urgent-request-button mb-h mobile-screen-button" onClick={handleModalClose}>Cancel</button>
                            <div className="mobile-full-width">
                                {
                                    [CLIENT_REQUEST_PENDING_ID,
                                        CLIENT_REQUEST_PENDING_CLIENT_ACTIONS_ID,
                                        CLIENT_REQUEST_IN_PROGRESS_CLIENT_ACTIONS_ID,
                                        CLIENT_REQUEST_APPROVED_ID,
                                    ].includes(requestStatus)  ?
                                    <React.Fragment>
                                        <div className="mb-h">
                                            <button className={`btn btn-danger urgent-request-button mobile-screen-button 
                                                    ${ declineLoading ? "no-pointer-events" : "" }`} onClick={e => handleRequest({action: "deny"})}>
                                                        {declineLoading ? "Declining" : "Deny"}
                                            </button>
                                        </div>
                                        { [CLIENT_REQUEST_PENDING_ID,
                                        CLIENT_REQUEST_PENDING_CLIENT_ACTIONS_ID,
                                        ].includes(requestStatus)  ?
                                        <React.Fragment>    
                                            <div className="mb-h">
                                                <button className={`btn btn-info urgent-request-button mobile-screen-button 
                                                        ${ pendingLoading ? "no-pointer-events" : "" }`} onClick={e => handleRequest({action: "pending"})}>
                                                            {pendingLoading ? 'Pending Client Action':'Pending'}
                                                </button>
                                            </div>
                                            <div className="mb-h">
                                                <button className={`btn btn-success urgent-request-button mobile-screen-button 
                                                        ${ approveLoading ? "no-pointer-events" : "" }`} onClick={e => handleRequest({action: "approve"})}>
                                                            {approveLoading ? "Approving":'Approve'}
                                                </button>
                                            </div>
                                        </React.Fragment>
                                            :
                                            <div className="mb-h">
                                                <button className={`btn btn-success urgent-request-button mobile-screen-button 
                                            ${saveLoading?'no-pointer-events' : ""}`} onClick={e => handleRequest({action: "save"})}>
                                                    {saveLoading ? "Saving":"Save"}
                                                </button>
                                            </div>
                                        }
                                    </React.Fragment>
                                    :
                                    <div className="mb-h">
                                        <button className={`btn btn-success urgent-request-button mobile-screen-button 
                                            ${saveLoading?'no-pointer-events' : ""}`} onClick={e => handleRequest({action: "save"})}>
                                                {saveLoading ? "Saving":"Save"}
                                        </button>
                                    </div>
                                }
                            </div>    
                        </div>
            ); 
        }
        else{
            return (<button className={`btn btn-success mobile-full-width mobile-screen-button ${submitLoading ? "no-pointer-events" : "" }`} onClick={e => handleRequest({action: "save"})}>
                    {submitLoading ? 
                        !requestStatus ? "Requesting" : "Saving"  
                        : 
                        !requestStatus ? submitButtonText : "Save"}
                </button>);
        }
        
    };

    const getNameDetails = () => {
        if(!activePendingRequest || !(activePendingRequest.communicationFirstName && activePendingRequest.communicationLastName)) return "N/A";
        return `${activePendingRequest.communicationFirstName} ${activePendingRequest.communicationLastName}`;
    };

    return(<Modal isOpen={viewRequestModal}  
               toggle={handleModalClose}
               style={{maxWidth: '1000px'}}
               >
                <ModalHeader 
                    close={<span className="bold hand" onClick={handleModalClose}>X</span>}
                >
                    {title}
                </ModalHeader>
                <ModalBody>
                    {
                        (activeRequestType==="tank") && !requestStatus &&
                        <Row className="mb-1">
                            <Col sm={2}>
                                <label className={"col-form-label"}>Location/Tank:</label>
                            </Col>
                            <Col sm={10} md={10} lg={5}>
                                <Select
                                    name="tanks"
                                    value={selectedTank.value}
                                    multi={false}
                                    clearable={true}
                                    simpleValue={false}
                                    options={tanks}
                                    onChange={(val) => handleTankChange(val)}
                                />  
                            </Col>
                        </Row>
                    }
                    {
                        requestStatus && instruction &&
                        <React.Fragment>
                            <label htmlFor='clientNotes' className="font-weight-bold mb-q">Additional Information</label>
                            <div className="mb-2" id="clientNotes">{instruction}</div>
                        </React.Fragment>
                    }
                    <div className='urgent-request-upload'>
                        <DragAndDropUpload handleChange={handleAttachmentFieldChange}/>
                    </div> 
                    <div className="flex flex-wrap mb-1">
                        {
                            mustBeArray(images).map((image,i) => {
                                return(
                                    <div className="mb-1 pl-1 pr-1 mt-2" key={i}>
                                        <div><img src={image.blobUri || image.fileContents} key={i} width="285px" height="100%" className="mb-q"/></div>
                                        <div className="mr-q float-left" style={{width: "270px",textOverflow: "ellipsis", overflow: "clip"}}>
                                            {image.fileName}
                                        </div>
                                        {
                                            !image.blobUri &&
                                            <i className="fa fa-times hand float-right pt-q text-danger" aria-hidden="true" onClick={e => handleFileDelete({image, index: i})} />
                                        }
                                        
                                        <div className="clearfix"/>
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div
                        className="mt-1"
                    >
                        <label htmlFor='feedback' className="font-weight-bold mb-h mt-h">{requestStatus ? "Feedback": "Additional Information"}</label>
                        <Input type="textarea" rows={5} id="feedback"  
                            value={notes} onChange={handleNoteChange} 
                            className={`${requestStatus && !isSuperAdmin ? 'no-pointer-events' : ""}`}
                        />
                    </div>
                    {
                        isSuperAdmin &&
                        <div>
                            <div className="mt-2 mb-1 font-weight-bold">Client Contacts</div>
                            {
                                <Row className="mb-1">
                                    <Col xs={4} md={2} lg={2}>
                                        Name
                                    </Col>
                                    <Col xs={8} md={7} lg={9}>
                                        {getNameDetails()}
                                    </Col>
                                </Row>
                            }
                            
                            {
                                <Row className="mb-1">
                                    <Col xs={4} md={2} lg={2}>
                                        {activePendingRequest.communicationType || "Mobile Phone"}
                                    </Col>
                                    <Col xs={8} md={7} lg={9}>
                                        {activePendingRequest && activePendingRequest.communicationDetail ? activePendingRequest.communicationDetail : "N/A" }
                                    </Col>
                                </Row>
                            }

                        </div>
                    }
                    {
                        isSuperAdmin && activePendingRequest &&
                        <div>
                            <div className="mt-2 mb-1 font-weight-bold">Status History</div>
                            <StatusHistoryList statusHistory={activePendingRequest.statusHistory} />
                        </div>
                    }
                </ModalBody>
                <ModalFooter>
                    {getModalFooter()}
                </ModalFooter>
        </Modal>);
};
export default UrgentRequestModal;